import { Filter } from '~commonInfra/utils/Filter';
import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { ListResultWithToken } from '~src/httpClient/fetchers/ListResultWithToken';
import { WebClientListWithTokenResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListWithTokenResourceFetcher';
import { ResourceQueryWithPagingToken } from '~src/httpClient/resources/ResourceQueryWithPagingToken';
import { NamedItemKeys } from '~src/spacesPlatform/models/resourceParts';
import { IServerUserInfo } from '~src/userManagement/users/models/IServerUserInfo';
import { GetServerUsersWithTokenRequest } from '~src/userManagement/users/serverApi/requests/GetServerUsersWithTokenRequest';


function fetchList(params: any): Promise<ListResultWithToken<IServerUserInfo>> {
    const listFetcher = new WebClientListWithTokenResourceFetcher(GetServerUsersWithTokenRequest, ServerApiMapper.serverUsersWithToken);
    return listFetcher.fetchList(params);
}

export const FetcherForServerUsersWithToken = {fetchList};

class ServerUsersWithToken extends ResourceQueryWithPagingToken<IServerUserInfo> {
    public static readonly instance = new ServerUsersWithToken(FetcherForServerUsersWithToken);

      // returns the server user with the specified username & domainName.
    public getUserByUsernameAndDomain(username: string, domainName: string): Promise<IServerUserInfo> {
        return this
        .addFilter(Filter.stringFieldEq('username', username))
        .addFilter(Filter.stringFieldEq('domainName', domainName))
        .getFirst();
    }

    // returns the server users with the specified IDs
    public getByUserIds(userIds: string[]): Promise<ListResultWithToken<IServerUserInfo>> {
        const usersFilter = Filter.stringFieldInArray(NamedItemKeys.id, userIds);
        const queryWithFilter = this.addFilter(usersFilter);

        return queryWithFilter.getCount().then((totalCount: number) => {
            return queryWithFilter.getPage(null, totalCount);
        });
    }
}

export const ServerUsersWithTokenResource = ServerUsersWithToken.instance;